import type { StudentLessonProgress as Progress } from "../../api/students";
import "./StudentLessonProgress.css";

type Props = {
  progress: Progress;
};

function pct(part: number, total: number): number | null {
  if (total <= 0) return null;
  return Math.min(100, Math.round((part / total) * 100));
}

export function StudentLessonProgressCell({ progress }: Props) {
  const { reserved, attended, no_show: noShow } = progress;
  const pending = Math.max(0, reserved - attended - noShow);
  const attendedPct = pct(attended, reserved);
  const ratioLabel = reserved > 0 ? `${attended}/${reserved}` : `${attended}/—`;

  return (
    <div className="kp-stu-progress">
      <div className="kp-stu-progress__top">
        <span className="kp-stu-progress__ratio" title="Katıldı / rezervasyon (iptal hariç)">
          {ratioLabel}
        </span>
        {attendedPct !== null && (
          <span className="kp-stu-progress__pct">%{attendedPct}</span>
        )}
      </div>
      {reserved > 0 && (
        <div
          className="kp-stu-progress__bar"
          role="progressbar"
          aria-valuenow={attended}
          aria-valuemin={0}
          aria-valuemax={reserved}
          title={`${attended} katıldı, ${noShow} gelmedi, ${pending} rapor bekliyor`}
        >
          {attended > 0 && (
            <span
              className="kp-stu-progress__segment kp-stu-progress__segment--ok"
              style={{ flexGrow: attended }}
            />
          )}
          {noShow > 0 && (
            <span
              className="kp-stu-progress__segment kp-stu-progress__segment--bad"
              style={{ flexGrow: noShow }}
            />
          )}
          {pending > 0 && (
            <span
              className="kp-stu-progress__segment kp-stu-progress__segment--pending"
              style={{ flexGrow: pending }}
            />
          )}
        </div>
      )}
      <div className="kp-stu-progress__meta" title="İptal hariç rezervasyonlar">
        <span>Rez {reserved}</span>
        <span className="kp-stu-progress__ok">Kat {attended}</span>
        <span className="kp-stu-progress__bad">Gelmedi {noShow}</span>
        <span className="kp-stu-progress__pending">Bekl {pending}</span>
      </div>
    </div>
  );
}

export function ExamReadyBadge({ ready }: { ready: boolean | null }) {
  if (ready === null) {
    return (
      <span
        className="kp-students__exam-ready kp-students__exam-ready--unknown"
        title="Henüz ders raporu yok"
      >
        —
      </span>
    );
  }
  return (
    <span
      className={`kp-students__exam-ready${ready ? " kp-students__exam-ready--yes" : " kp-students__exam-ready--no"}`}
      title="Son ders raporundaki işaret"
    >
      {ready ? "Evet" : "Hayır"}
    </span>
  );
}
